import * as Yup from "yup";

export const promotionSchema = Yup.object().shape({
  promotionName: Yup.string()
    .min(2, "Nombre demaciado corto")
    .required("Campo requerido"),
  distributorTypeIds: Yup.array()
    .min(1, "Selecciona al menos un tipo de distribuidor")
    .required("Campo requerido"),
  discountTarget: Yup.string().required("Campo requerido"),
  discountPercentage: Yup.string().required("Campo requerido"),
  promotionStartAt: Yup.string().required("Campo requerido"),
  promotionEndsAt: Yup.string().nullable(),
  applyBy: Yup.string().required("Campo requerido"),
});
